export const RESERVATION_SERVICE_KEYS = Object.freeze({
  MAKERSHOT: "makershot",
  PREMIUM: "premium",
  AVIQUE: "avique",
  SELIMERRY: "selimerry",
  PRINCESS_STORY: "princess_story",
})

const SERVICE_ALIASES = Object.freeze({
  makershot: RESERVATION_SERVICE_KEYS.MAKERSHOT,
  maker_shot: RESERVATION_SERVICE_KEYS.MAKERSHOT,
  "maker-shot": RESERVATION_SERVICE_KEYS.MAKERSHOT,
  premium: RESERVATION_SERVICE_KEYS.PREMIUM,
  premiumshot: RESERVATION_SERVICE_KEYS.PREMIUM,
  premium_shot: RESERVATION_SERVICE_KEYS.PREMIUM,
  "premium-shot": RESERVATION_SERVICE_KEYS.PREMIUM,
  avique: RESERVATION_SERVICE_KEYS.AVIQUE,
  selimerry: RESERVATION_SERVICE_KEYS.SELIMERRY,
  sellymerry: RESERVATION_SERVICE_KEYS.SELIMERRY,
  princess_story: RESERVATION_SERVICE_KEYS.PRINCESS_STORY,
  princessstory: RESERVATION_SERVICE_KEYS.PRINCESS_STORY,
  "princess-story": RESERVATION_SERVICE_KEYS.PRINCESS_STORY,
})

export function normalizeReservationServiceKey(value) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
  return SERVICE_ALIASES[normalized] || ""
}

export function findReservationPromotion(item, promotions = []) {
  const suppliedCode = item && (item.promotionCode || item.promotion_code)
  const targetCode = String(suppliedCode || "default").toLowerCase()
  const exact = promotions.find(
    (promotion) =>
      String((promotion && promotion.code) || "").toLowerCase() === targetCode
  )
  if (exact || suppliedCode) {
    return exact || null
  }
  return (
    promotions.find(
      (promotion) =>
        String((promotion && promotion.code) || "").toLowerCase() === "default"
    ) || null
  )
}

function resolveLegacyPromotionServiceKey(promotion) {
  if (!promotion) {
    return ""
  }

  const conceptId = promotion.conceptId || promotion.concept_id
  const isIndividual = Number(
    promotion.isIndividual !== undefined
      ? promotion.isIndividual
      : promotion.is_individual
  )

  return conceptId || isIndividual === 1
    ? RESERVATION_SERVICE_KEYS.PREMIUM
    : RESERVATION_SERVICE_KEYS.MAKERSHOT
}

export function resolveReservationServiceKey(item, promotions = []) {
  if (!item) {
    return ""
  }

  const direct = normalizeReservationServiceKey(
    item.serviceKey || item.service_key
  )
  if (direct) {
    return direct
  }

  const promotion = findReservationPromotion(item, promotions)
  const promoted = normalizeReservationServiceKey(
    promotion && (promotion.serviceKey || promotion.service_key)
  )
  if (promoted) {
    return promoted
  }

  const productType = normalizeReservationServiceKey(
    item.productType || item.product_type
  )
  if (productType) {
    return productType
  }

  const legacyPromoted = resolveLegacyPromotionServiceKey(promotion)
  if (legacyPromoted) {
    return legacyPromoted
  }

  return ""
}

export function refundPolicyProductType(item, promotions = []) {
  const serviceKey = resolveReservationServiceKey(item, promotions)
  if (!serviceKey) {
    return ""
  }
  return serviceKey === RESERVATION_SERVICE_KEYS.MAKERSHOT
    ? RESERVATION_SERVICE_KEYS.MAKERSHOT
    : RESERVATION_SERVICE_KEYS.PREMIUM
}

export function usesDirectPhotoDelivery(item, promotions = []) {
  const serviceKey = resolveReservationServiceKey(item, promotions)
  return Boolean(serviceKey) && serviceKey !== RESERVATION_SERVICE_KEYS.MAKERSHOT
}
